import React from 'react'
import PropTypes from 'prop-types'
import {Grid, Typography, withStyles} from "@material-ui/core";
import Tr from "translations/Translations";
import TextInput from "components/TextInput";
import INPUT_TYPE from "constants/INPUT_TYPE";
import Form from "components/Form";
import VS from "constants/ValidationShema";
import moment from "libs/moment";
import DateFormats from "constants/DateFormats";

const style = theme => ({
    root: {},
    limit: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        color: theme.palette.text.secondary,
    },
    relative: {
        position: 'relative'
    }
})

function RealizationAmountForm(
    {
        formId,
        realizationValues,
        required,
        editable,
        onSubmit,
        classes
    }) {


    const getInitValues = () => {
        const init = {
            dealings: realizationValues.dealings.map(({realizationGrossValue, identity}) => ({
                realizationGrossValue,
                identity
            }))
        };
        return init;
    }

    const getValidationSchema = () => {
        const shape = {
            realizationGrossValue: required ? VS.amount(0, true) : VS.amountOptional(0, true)
        }

        return VS.object({
            dealings: VS.lazy(x => {
                return VS.arrayOfShape(shape)
            })
        })
    }

    const formatPublishDate = (publishDate) => {
        return moment(publishDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT);
    }

    return (<Form
        id={formId}
        initialValues={getInitValues()}
        validationSchema={getValidationSchema()}
        onSubmit={onSubmit}
    >
        {(formikProps) => (
            <>
                <Grid container spacing={3}>
                    {realizationValues.dealings.map((x, i) =>
                        (<Grid item key={x.identity} xs={4}>
                            <div className={classes.relative}>
                                <TextInput
                                    id={`dealings.${i}.realizationGrossValue`}
                                    label={realizationValues.dealings.length > 1 ? Tr('part_x', {x: i + 1}) : ''}
                                    formikProps={formikProps}
                                    type={INPUT_TYPE.NUMBER_19}
                                    disabled={!editable}
                                    required={required}
                                />
                                {x.realizationPublishDate && <Typography key={x.identity} variant='caption' className={classes.limit}>{Tr('realization_publish_date')}{realizationValues.dealings.length > 1 ? Tr('on_part_x', {x: i + 1}) : ''}: {formatPublishDate(x.realizationPublishDate)}</Typography>}
                            </div>
                        </Grid>))
                    }
                </Grid>
            </>)}
    </Form>)
}

RealizationAmountForm.propTypes = {
    formId: PropTypes.string.isRequired,
    realizationValues: PropTypes.shape({
        dealings: PropTypes.array.isRequired,
        realizationValuePublished: PropTypes.bool
    }).isRequired,
    required: PropTypes.bool.isRequired,
    editable: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default withStyles(style)(RealizationAmountForm);